<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDeny_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M18.44 20.56a1.5 1.5 0 0 0 2.12-2.12L14.122 12l6.44-6.44a1.5 1.5 0 0 0-2.122-2.12L12 9.878l-6.44-6.44a1.5 1.5 0 1 0-2.12 2.122L9.878 12l-6.44 6.44a1.5 1.5 0 0 0 2.122 2.12L12 14.122z"
        clip-rule="evenodd"
    />
</svg>
